module.exports = __webpack_public_path__ + "img/san_marino.8838aed.webp";